import { api } from '@marketplace-web/core-api/core-api-client-util'

import { EditFeedbackCommentArgs, FeedbackCommentResp } from '../types/feedback-comment'

export const editFeedbackComment = ({ feedbackId, comment }: EditFeedbackCommentArgs) =>
  api.put<FeedbackCommentResp>(`/user_feedbacks/${feedbackId}/comment`, {
    comment,
  })
